/**
 * Types and constants for emoji reactions feature
 *
 * NOTE: EmojiType is generated from the OpenAPI spec. The source of truth for
 * available emojis is: web-application/api/components/schemas/reactions.yaml
 *
 * This file only adds display metadata (emoji characters and labels) that
 * cannot be represented in the OpenAPI spec enum.
 */

// Import the generated type from API
import { EmojiType, ReactionOutput, ReactionSummary, ReactionsResponse } from '../../generated-api';

// Re-export for convenience
export type { EmojiType, ReactionOutput, ReactionSummary, ReactionsResponse };

/**
 * Display metadata for emojis.
 * Maps EmojiType codes to their visual representation.
 *
 * Source of truth for codes: web-application/api/components/schemas/reactions.yaml#EmojiType
 */
export const EMOJI_DISPLAY: Record<EmojiType, { emoji: string; label: string }> = {
  heart: { emoji: '❤️', label: 'Heart' },
  trophy: { emoji: '🏆', label: 'Trophy' },
  fire: { emoji: '🔥', label: 'Fire' },
  mad: { emoji: '😠', label: 'Mad' },
  devil: { emoji: '😈', label: 'Devil' },
  laugh: { emoji: '😂', label: 'Laughing' },
  thumbsup: { emoji: '👍', label: 'Thumbs Up' },
  clap: { emoji: '👏', label: 'Clapping' },
  mindblown: { emoji: '🤯', label: 'Mind Blown' },
  sad: { emoji: '😢', label: 'Sad' },
  party: { emoji: '🎉', label: 'Party' },
  poop: { emoji: '💩', label: 'Poop' },
};

/**
 * Ordered list of all available emoji codes for iteration.
 * Derived from EmojiType to ensure type safety.
 */
export const EMOJI_CODES: EmojiType[] = [
  'heart',
  'trophy',
  'fire',
  'mad',
  'devil',
  'laugh',
  'thumbsup',
  'clap',
  'mindblown',
  'sad',
  'party',
  'poop',
];

/**
 * Combined emoji data for components that need both code and display info.
 * This replaces the old EMOJIS constant.
 */
export const EMOJIS = EMOJI_CODES.map(code => ({
  code,
  ...EMOJI_DISPLAY[code],
}));

// Legacy type alias for backward compatibility
export type EmojiCode = EmojiType;
